import axios from 'axios';
import {
  detectDiscontinuitiesInM3u8,
  truncatePlaylistAtDiscontinuity,
} from './video.util';
import Hls from 'hls.js';

export class pLoader extends Hls.DefaultConfig.loader {
  constructor(config) {
    super(config);
    this.eventTarget = new EventTarget();

    this.boundOnSuccess = this.onSuccess.bind(this);
    const load = this.load.bind(this);

    this.load = (context, config, callbacks) => {
      if (context.type === 'level') {
        callbacks.onSuccess = this.boundOnSuccess.bind(
          this,
          callbacks.onSuccess
        );
      }
      load(context, config, callbacks);
    };
  }

  // Subscribe to 'parsedData' event using addEventListener
  onParsedData(callback) {
    this.eventTarget.addEventListener('parsedData', callback);
    this.callback = callback;
  }

  // Clean up method to remove event listeners
  dispose() {
    if (this.callback) {
      this.eventTarget.removeEventListener('parsedData', this.callback);
    }
  }

  async onSuccess(originalOnSuccess, response, stats, context) {
    let processedData = response.data;
    // ignore truncate playlist in LIVE stream
    const isLive = this.detectLivePlaylist(processedData);
    if (isLive) {
      originalOnSuccess(response, stats, context);
      return;
    }
    // get the fetch url from the context
    const fetchUrl = context.url.split('getHLSMediaPlaylist.m3u8?')[0];

    const discontinuityFragments = detectDiscontinuitiesInM3u8(
      processedData,
      fetchUrl
    );

    const event = new CustomEvent('parsedData', { detail: processedData });
    if (discontinuityFragments.length > 0) {
      try {
        await axios.get(discontinuityFragments[0].url);
      } catch (error) {
        console.error('Error fetching first discontinuity fragment:', error);

        processedData = truncatePlaylistAtDiscontinuity(
          processedData,
          discontinuityFragments
        );
        console.warn('[WARN] Playlist truncated due to first fragment error.');

        this.eventTarget.dispatchEvent(event);

        originalOnSuccess({ ...response, data: processedData }, stats, context);
        return;
      }
    }
    this.eventTarget.dispatchEvent(event);

    originalOnSuccess(response, stats, context);
  }

  detectLivePlaylist(playlistContent) {
    // check for EXT-X-ENDLIST tag
    if (playlistContent.includes('#EXT-X-ENDLIST')) {
      return false; // VOD
    }

    // check for EXT-X-PLAYLIST-TYPE tag
    const playlistTypeMatch = playlistContent.match(
      /#EXT-X-PLAYLIST-TYPE:(\w+)/
    );
    if (playlistTypeMatch) {
      if (playlistTypeMatch[1] === 'VOD') {
        return false; // VOD
      } else if (playlistTypeMatch[1] === 'EVENT') {
        return true; // LIVE event
      }
    }

    // if neither tag is present, assume it is LIVE
    return true;
  }
}
